import styled from '@emotion/styled';

export const TableFooterContent = styled.div`
    display: flex;
    align-items: center;
    font-size: ${({ theme }): string => theme.font.size.normal};
`;
